import React from 'react'
import Counter, { CounterProps } from './Counter'
import './Counter.css'

interface LabeledCunterProps extends CounterProps {
    rightLabel?: string
    rightSubLabel?: string
}

const LabeledCounter = ({ rightLabel, rightSubLabel, ...props }: LabeledCunterProps) => {
    return (
        <div className="labeled-counter__wrapper" style={{ columnGap: 20 }}>
            {!!rightLabel && <p className="labeled-counter__label" style={{marginTop: props.label?.length ? "" : "10px"}}>
                {rightLabel}
                {!!rightSubLabel && <span className='labeled-counter__sublabel'>
                    {rightSubLabel}
                </span>}
            </p>}
            <Counter
                {...props}
            />
        </div>
    )
}

export default LabeledCounter